import React from 'react';
import {Route, Switch} from 'react-router-dom';

import NetworksList from 'routes/app/components/Configuration/NetworkList';
import NetworkForm from 'routes/app/components/Configuration/NetworkForm';

class PhoneSms extends React.Component {

  render() {
    return (
      <Switch>
        <Route path={`${this.props.match.path}/edit/:id`}
               render={( props ) => <NetworkForm type="phone" {...props}/>}/>
        <Route path={`${this.props.match.path}/new`} render={( props ) => <NetworkForm type="phone" {...props}/>}/>
        <Route path={`${this.props.match.path}`} render={() => <NetworksList type="phone"/>}/>
      </Switch>
    )
  }
}

module.exports = PhoneSms;



// WEBPACK FOOTER //
// ./routes/app/routes/configuration/phone/index.js